module.exports = __webpack_public_path__ + "img/avatar4.28d9c319.png";